import React, { useState, useEffect } from 'react'
import { Select } from "antd";
import { getProvinceMunicipalities, MapMunicipality, MapMunicipalityWitGeojson, MapProvince } from '../../../services/map-municipalities.service';
import { ADD_ALL_ID } from './MapMunicipalitySearchForm';
import { SelectValue } from 'antd/lib/select';
import styled from 'styled-components';

type MapMunicipalitySelectProps = {
  disabled: boolean,
  selectedMunicipalities: MapMunicipality[],
  selectedProvinces: MapProvince[],
  lastSelectedProvince?: MapProvince,
  handleProvinceSelection: (province: MapProvince) => void
  handleSelection: (municipality: MapMunicipalityWitGeojson) => void
}

export const MapMunicipalitySelect: React.FC<MapMunicipalitySelectProps> = ({
  selectedMunicipalities,
  selectedProvinces,
  lastSelectedProvince,
  handleProvinceSelection,
  handleSelection,
  disabled
}) => {

  const [municipalities, setMunicipalities] = useState<MapMunicipalityWitGeojson[]>([]);
  const [selectedMunicipality, selectMunicipality] = useState<MapMunicipalityWitGeojson>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!lastSelectedProvince) {
      setMunicipalities([]);
      selectMunicipality(undefined);
      return;
    }

    const controller = new AbortController();
    setLoading(true);
    selectMunicipality(undefined);

    getProvinceMunicipalities(lastSelectedProvince, controller.signal).then(data => {
      if (data) {
        const extendedData = [{ id: ADD_ALL_ID, province: lastSelectedProvince, name: "Toda la provincia", separated: true }, ...data];
        setMunicipalities(extendedData);
      }
    }).catch(err => {
      if (err.name !== 'AbortError') {
        console.error('Error fetching municipalities:', err);
      }
    }).finally(() => setLoading(false));

    return () => controller.abort();
  }, [lastSelectedProvince]);

  const { Option } = Select

  const onChange = (value: SelectValue) => {
    if (value === selectedMunicipality?.id) {
      return;
    }
    const municipality = municipalities.find(it => it.id === value)
    if (!municipality)
      return;

    selectMunicipality(municipality)
    if (municipality.id === ADD_ALL_ID) {
      handleProvinceSelection(lastSelectedProvince!)
    } else {
      handleSelection(municipality)
    }
  }

  const allMunicipalitiesOptionSelected = selectedProvinces.some(it => it.id === lastSelectedProvince?.id);

  return <SearchBar
    size="large"
    showSearch
    placeholder="Municipio"
    optionFilterProp="children"
    onChange={onChange}
    loading={loading}
    value={allMunicipalitiesOptionSelected ? municipalities[0]?.id : selectedMunicipality?.id}
    disabled={!lastSelectedProvince || disabled}>
    {municipalities.map((se: any) => (
      <Option key={se.id} value={se.id} disabled={selectedMunicipalities.some(it => it.id === se.id)|| allMunicipalitiesOptionSelected}>
        {se.name}
      </Option>
    ))}
  </SearchBar>
}

const SearchBar = styled(Select)`
  width: 100%;
`